import React, { useState, useEffect } from "react";
import { Button, Typography, Box, useTheme } from "@mui/material";
// import { width } from "@mui/system";
import Slider from "react-slick";
import QRCODEIcon from "../../Svg/QRCODEIcon";
import { Icon } from "@mui/material";
import RedQuesMarkIcon from "../../Svg/RedQuesMarkIcon";
import "./Slider.css";

const CustomSlider = ({ cards = [] }) => {
  //const
  const theme = useTheme();
  const [cardsCount, setCardsCount] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    setCardsCount(cards?.length);
  }, [cards]);

  return (
    <Box className="Slide">
      <Slider {...settings}>
        {cards?.map((cards, index) => (
          <Box className="imgBackground">
            <Box p={2} display={"inline-block"}>
              <Typography variant="h5" sx={{ color: "white", padding: "13px" }}>
                <QRCODEIcon /> {cards?.name}
              </Typography>
              <Typography variant="p" sx={{ color: "gray", padding: "13px" }}>
                Wallet Balance {index + 1}/{cardsCount} <RedQuesMarkIcon />
              </Typography>
              <Typography variant="h5" sx={{ color: "white", padding: "13px" }}>
                {" "}
                {cards?.currency || "NGN"} {cards?.balance || "0.00"}
              </Typography>
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default CustomSlider;
